export default "__VITE_ASSET__eB0kgbNK__"